import {
  WecomFileMessageType,
  WecomGifMessageType,
  WecomImageMessageType,
  WecomLinkMessageType,
  WecomMessageType,
  WecomMiniProgramMessageType,
  WecomMixedMessageType,
  WecomMsgType,
  SendContentType,
  SendingStatus,
  WecomTextMessageType,
  WecomVideoMessageType,
  WecomVideoNumMessageType,
} from "../../types";
import {
  SendWecomMessageParams,
  WecomFileSendData,
  WecomGifSendData,
  WecomLinkSendData,
  WecomMiniProgramSendData,
  WecomSendDataType,
  WecomTextMixedSendData,
  WecomTextSendData,
  WecomVideoNumSendData,
  WecomVideoSendData,
} from "./send-message";

export const makeWecomTextMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomTextSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.TEXT,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    content: send_data?.content,
  } as WecomTextMessageType;
};

export const makeWecomGifMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomGifSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.GIF,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WecomGifMessageType;
};
export const makeWecomTextMixedMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomTextMixedSendData;
  let content = "";
  const at_list = [] as { nickname: string; user_id: string }[];
  send_data?.content?.forEach(
    (item: { subtype: number; text: string; nickname?: string }) => {
      if (item.subtype === 1) {
        let id = item.text;
        if (id) {
          content += `@${item?.nickname} `;
          at_list.push({
            nickname: item?.nickname || "",
            user_id: item.text,
          });
        } else {
          content += `@所有人 `;
          at_list.push({
            nickname: " ",
            user_id: "0",
          });
        }
      } else if (item.subtype === 0) {
        // 普通文本
        content += item.text + " ";
      }
    }
  );
  return {
    at_list,
    content,
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.TEXT_2,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
  } as WecomMixedMessageType;
};

export const makeWecomImageMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomGifSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.WECHAT_IMAGE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WecomImageMessageType;
};

export const makeWecomLinkMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomLinkSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.LINK,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    ...send_data,
  } as WecomLinkMessageType;
};

export const makeWecomFileMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomFileSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.WECOM_FILE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_name: send_data?.file_name,
    file_url: send_data?.path,
  } as WecomFileMessageType;
};

export const makeWecomVideoMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomVideoSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.WECOM_VIDEO,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WecomVideoMessageType;
};

export const makeWecomVideoNumMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomVideoNumSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.VIDEO_NUM,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    channel_name: send_data?.channel_name,
    channel_url: send_data?.channel_url,
    encode_data: send_data?.encode_data,
    head_img_url: send_data?.head_img_url,
    username: send_data?.username,
    thumburl: send_data?.thumb_url,
  } as WecomVideoNumMessageType;
};

export const makeWecomMiniProgarmMsg = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WecomMiniProgramSendData;

  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msgtype: WecomMsgType.MINI_PROGRAM,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    title: send_data.title,
    desc: send_data.desc,
    headimg: send_data.thumburl,
    appid: send_data.appid,
    cover_image_aeskey: send_data.cover_file_aeskey,
    cover_image_id: send_data.cover_file_id,
    cover_image_md5: send_data.cover_file_md5,
    cover_image_size: send_data.cover_file_size,
    username: send_data.username,
  } as WecomMiniProgramMessageType;
};

export const makeWecomMessage = (
  send_message_params: Omit<
    SendWecomMessageParams<WecomSendDataType>,
    "service_type"
  >
): WecomMessageType | undefined => {
  switch (send_message_params?.data?.type) {
    case SendContentType.TEXT: {
      return makeWecomTextMsg(send_message_params);
    }
    case SendContentType.MENTION: {
      return makeWecomTextMixedMsg(send_message_params);
    }
    case SendContentType.GIF: {
      return makeWecomGifMsg(send_message_params);
    }
    case SendContentType.IMAGE: {
      return makeWecomImageMsg(send_message_params);
    }
    case SendContentType.LINK: {
      return makeWecomLinkMsg(send_message_params);
    }
    case SendContentType.FILE: {
      return makeWecomFileMsg(send_message_params);
    }
    case SendContentType.VIDEO: {
      return makeWecomVideoMsg(send_message_params);
    }
    case SendContentType.VIDEO_NUM: {
      return makeWecomVideoNumMsg(send_message_params);
    }
    case SendContentType.MINI_PROGRAM: {
      return makeWecomMiniProgarmMsg(send_message_params);
    }
    default:
      return;
  }
};
